<template>
  <swiper
    :modules="modules"
    :slides-per-view="perView"
    :space-between="20"
    :autoHeight="true"
    :loop="loop"
    :speed="1500"
    :navigation="{ nextEl: `.swiper-next-${id}`, prevEl: `.swiper-prev-${id}` }"
    :pagination="{ clickable: true }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
    :breakpoints="breakpoints"
    :autoplay="autoplay">
    <slot></slot>
  </swiper>
  <span :class="`swiper-next-${id} swiper-button-next`"></span>
  <span :class="`swiper-prev-${id} swiper-button-prev`"></span>
</template>
<style>
  .swiper-slide {
      height:100% !important;
  }
</style>
<script>
  import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';

  import { Swiper, SwiperSlide } from 'swiper/vue';

  SwiperCore.use([Pagination, Navigation, Autoplay]);

  export default {
    props: {
      perView: {
        type: Number,
        default: 1,
      },

      loop: {
        type: Boolean,
        default: false,
      },

      autoplay: Boolean,

      breakpoints: {
        type: Object,
        default: function () {
          return {
            768: { slidesPerView: 2 }
          }
        }
      }
    },
    components: {
      Swiper,
      SwiperSlide,
    },
    data() {
      return {
        modules: [Navigation, Pagination],
        id: Math.floor(Math.random() * (999999 - 100000 + 1) ) + 100000,
      }
    },
    methods: {
      onSwiper(swiper) {
        //
      },
      onSlideChange() {
        //
      },
    },
  };
</script>
